
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import ObjectEditAttributeCombobox from './ObjectEditAttributeCombobox';
import ObjectEditAttributeDate from './ObjectEditAttributeDate';
import ObjectEditAttributeFloat from './ObjectEditAttributeFloat';
import ObjectEditAttributeInteger from './ObjectEditAttributeInteger';
import ObjectEditAttributeText from './ObjectEditAttributeText';

import { IfComp, Log } from '../../../core';
const log = Log.getLogger('MultiSceneForApp.data.components.objectEdit.ObjectEditAttribute');

const EDIT_ATTRIBUTE_TYPES = {
    combobox: ObjectEditAttributeCombobox,
    date: ObjectEditAttributeDate,
    float: ObjectEditAttributeFloat,
    integer: ObjectEditAttributeInteger,
    text: ObjectEditAttributeText
};

const ObjectEditAttribute = ({
    allow,
    attribute,
    dataModel,
    mode,
    onChange,
    value
}) => {

    const classNames = mergeStyleSets({
        ObjectEditAttribute: {
        },
        clear: {
            width: 26
        }
    });

    const getEditorType = () => {
        let editorType = 'text';
        if (allow) {
            if (attribute.values) {
                editorType = 'combobox';
            } else {
                if (attribute.type === 'date') {
                    editorType = 'date';
                }
                if (attribute.type === 'float') {
                    editorType = 'float';
                }
                if (attribute.type === 'integer') {
                    editorType = 'integer';
                }
            }
        }
        return editorType;
    }

    const editorType = getEditorType();

    let attributeComponent = EDIT_ATTRIBUTE_TYPES[editorType];
    if (!attributeComponent) {
        log.warn(`unknown editor type: ${editorType}`);
        attributeComponent = ObjectEditAttributeText;
    }

    const handleClear = () => {
        if (onChange) {
            onChange(attribute.name, null);
        }
    }

    const handleChange = (attrName, value) => {
        if (onChange) {
            onChange(attrName, value);
        }
    }

    return (
        <Stack horizontal verticalAlign="end">
            <Stack.Item grow>
                {
                    React.createElement(
                        attributeComponent, {allow, attribute, dataModel, value, onChange: handleChange}
                    )
                }
            </Stack.Item>
            <Stack.Item className={classNames.clear}>
                <IfComp cond={((attribute.type === 'date') && allow)}>
                    <CommandButton
                        onClick={handleClear}
                        disabled={!allow}
                        title="Vymazat hodnotu atributu"
                        iconProps={{
                            iconName: 'Clear',
                            styles: {
                                root: {
                                    fontSize: 8
                                }
                            }
                        }}
                    />
                </IfComp>
            </Stack.Item>
        </Stack>
    );
}

export default ObjectEditAttribute;
